import { AfterViewInit, Component, Renderer2, viewChild } from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-theme-toggle',
  templateUrl: './theme-toggle.component.html',
  styleUrls: ['./theme-toggle.component.scss']
})
export class ThemeToggleComponent implements AfterViewInit {

  darkModeSwitch = viewChild.required(MatSlideToggle);
  checked = false;
  
  constructor(private renderer: Renderer2) {}


  ngAfterViewInit() {
    this.setIcon();
  }

  setIcon() {
    if (this.darkModeSwitch()) {
      const targetSpan = this.darkModeSwitch()._switchElement.nativeElement.querySelector('.mdc-switch__icons');
      if (targetSpan) {
        while (targetSpan.firstChild) {
          targetSpan.firstChild.remove();
        }
        const elem = this.renderer.createElement('mat-icon');
        const icon = this.checked ? 'dark_mode' : 'light_mode';
        elem.setAttribute('class', 'mat-icon notranslate material-icons mat-icon-no-color light-mode-switch-icon');
        elem.textContent = icon;
        targetSpan.appendChild(elem);
      }
    }
  }

  changeTheme() {
    this.checked = !this.checked;
    this.setIcon();
  }
}